
<details>
    <summary>
        <slot name="summary"/>
    </summary>
    <slot name="details"/>
</details>


<style lang="less">
    summary {
        display: inline-block;
        color: darkblue;
        cursor: pointer;
        &:hover, &:focus {
            text-decoration: underline;
        }
    }
</style>